import type {
  AssignmentTypeFilter,
  ClassworkCreatedByFilter,
  ClassworkGradingStateFilter,
  SelectOption
} from '../types';

export const CREATED_BY_CHECKBOX_OPTIONS: ReadonlyArray<SelectOption<ClassworkCreatedByFilter>> = [
  {value: 'you', label: 'You'},
  {value: 'someoneElse', label: 'Others'}
];

export const ASSIGNMENT_TYPE_CHECKBOX_OPTIONS: ReadonlyArray<SelectOption<AssignmentTypeFilter>> = [
  {value: 'assignment', label: 'Assignment'},
  {value: 'exam', label: 'Assessment'}
];

// Labelled as in the grading view's own student filter, so the two surfaces name the same states
// the same way.
export const GRADING_STATE_CHECKBOX_OPTIONS: ReadonlyArray<
  SelectOption<ClassworkGradingStateFilter>
> = [
  {value: 'needsGrading', label: 'Needs Grading'},
  {value: 'gradingComplete', label: 'Grading Complete'}
];
